module.exports = __webpack_public_path__ + "static/img/failed_bj.df081d0.png";